export const whyChooseUsData = [
  {
    title: 'Comprehensive Care',
    text: `Our healthcare clinic offers a wide range of services designed to address all aspects of your health, from preventive care to specialized treatments.`,
    icon: 'fas fa-heartbeat'
  },
  {
    title: 'Experienced Healthcare Professionals',
    text: `Our team of healthcare professionals has years of experience in the industry and is dedicated to providing the highest quality care to each and every patient.`,
    icon: '',
  },
  {
    title: 'Personalized Care',
    text: `At our healthcare clinic, we understand that every patient is unique, and we take the time to get to know you and your specific health needs. `,
    icon: '',
  },
  {
    title: 'State-of-the-Art Technology',
    text: `We are committed to staying up-to-date with the latest medical technology and techniques, so you can rest assured that you are receiving the most advanced care possible.`,
    icon: '',
  },
  {
    title: 'Convenient Location',
    text: `Our healthcare clinic is located in a central and convenient location, making it easy for you to access the healthcare services you need. `,
    icon: '',
  },
  {
    title: 'Affordable Care',
    text: `We believe that everyone deserves access to high-quality healthcare, which is why we strive to keep our prices reasonable and affordable.`,
    icon: '',
  },
]